import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_images",
  "use": "svg_images-usage",
  "viewBox": "0 0 21 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 16\" id=\"svg_images\"><path d=\"M20 14a1 1 0 0 1-1 1H2.5A1.5 1.5 0 0 1 1 13.5v-11A1.5 1.5 0 0 1 2.5 1h16A1.5 1.5 0 0 1 20 2.5V14Z\" stroke=\"currentColor\" /><path d=\"m19.854 13-4-4-3 3-7-7L1 9.854\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M15 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z\" stroke=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol